import React, {useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';
import styled from '@emotion/styled';
import CloseSmall from 'foundation/icons/closeSmall';

interface ToastProps {
    message: string;
    isVisible: boolean;
    onClose: () => void;
    duration?: number;
    autoClose?: boolean;
}

export default function Toast({message, isVisible, onClose, duration = 3000, autoClose = true}: ToastProps) {
    const timerRef = useRef<NodeJS.Timeout>();

    useEffect(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        if (isVisible && duration > 0 && autoClose) {
            timerRef.current = setTimeout(() => {
                onClose();
            }, duration);
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [isVisible, message, duration, onClose, autoClose]);

    if (!isVisible) return null;

    return createPortal(
        <ToastContainer>
            <span>{message}</span>
            <button onClick={onClose}>
                <CloseSmall color='#fff' />
            </button>
        </ToastContainer>,
        document.body,
    );
}

const ToastContainer = styled.div`
    margin: 0 auto;
    padding: 10px 20px;
    position: fixed;
    bottom: 140px;
    left: 0;
    right: 0;
    color: #fff;
    display: flex;
    width: calc(100% - 30px);
    max-width: calc(var(--max-width) - 30px);
    height: 48px;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    border-radius: 30px;
    background: rgba(34, 34, 34, 0.7);
    z-index: 9999;

    > button {
        padding: 10px 0 10px 0px;
        cursor: pointer;
        background: none;
        border: none;
    }
`;
